import { Container, Col, Row } from "reactstrap";
import "../styles/Founder.css";
import FounDer from "../assests/founder.png";

function Founder() {
  return (
    <Container fluid className="founder">
      <Row className="testimonal1">
        <div className="found-head">
          <h2>
            Meet <br className="braking-none" /> Mr.Subash Chandra Bose
          </h2>
          <p>-founder of Harini</p>
        </div>

        <Col lg="6" md="6" sm="6" xs="12">
          <div className="testimonal-img">
            <img src={FounDer} alt="" />
          </div>
        </Col>
        <Col lg="6" md="6" sm="6" xs="12">
          <div className="testimonal-content">
            <p>
              Meet the visionary behind Harini, Mr. Subhash Chandra Bose. With a
              profound passion for dairy excellence and a commitment to
              tradition, Mr. Bose established Harini with the goal of redefining
              the dairy industry. His journey began with a simple belief: that
              the purest, freshest dairy products should be accessible to
              everyone. Guided by this vision, he has led Harini to become a
              symbol of quality and sustainable dairy practices. Mr. Subhash
              Chandra Bose's dedication to the farm-to-table approach has made
              Harini a trusted name in dairy products, where every product is a
              reflection of his unwavering commitment to purity and taste.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Founder;
